import { render, staticRenderFns } from "./ReportBudgetTextEditor.vue?vue&type=template&id=4a07fe88&"
import script from "./ReportBudgetTextEditor.vue?vue&type=script&lang=js&"
export * from "./ReportBudgetTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./ReportBudgetTextEditor.vue?vue&type=style&index=0&id=4a07fe88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports